import getRealFieldType from "v4/pages/admin/ViewOrders/contexts/utils/getRealFieldType";
import {CHOICE_TYPE} from "v4/data/fieldTypes";

export default function schemaFormToV4Form(response) {
    if (!response?.schema?.['hydra:member']?.[2]) return null;

    const sortByPropertyOrder = (a, b) => {
        const orderA = a[1].propertyOrder ?? 0;
        const orderB = b[1].propertyOrder ?? 0;

        return orderA - orderB;
    }

    return Object.entries(response.schema['hydra:member'][2]).sort(sortByPropertyOrder).reduce((acc, [key, fieldData]) => {
        const field = {
            label: fieldData.title,
            type: getRealFieldType(fieldData),
            value: fieldData.value ?? '',
            attr: fieldData.attr ?? {},
            constraints: {
                required: fieldData.required ?? false,
            },
            name: key,
        }

        if (CHOICE_TYPE === field.type) {
            const enumChoices = {
                enum: fieldData.items ? fieldData.items.enum : fieldData.enum,
                enum_titles: fieldData.items ? fieldData.items.enum_titles : fieldData.enum_titles,
            };

            const choiceTypeData = {
                choices: enumChoices.enum.map((value, index) => ({
                    label: enumChoices.enum_titles[index],
                    value: value
                })),
                multiple: fieldData.type !== 'string',
            }

            Object.assign(field, choiceTypeData);
        }

        return {
            ...acc,
            [key]: field
        };
    }, {});
}
